module.exports = __webpack_public_path__ + "362c2a6bc1ebeaa35fa9902416252acb.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/Lankenau.jpg
// module id = 619
// module chunks = 0